const RESPONSAVEIS = 'Projeto GEF Áreas Privadas — Ministério do Meio Ambiente e Mudança do Clima'

/*
 * Rodapé das páginas de conteúdo, como o da página pública do projeto: a marca
 * horizontal do Projeto GEF Áreas Privadas sobre branco, com a divisa acima, e
 * a linha dos responsáveis no verde da marca. A tela de mapa não tem rodapé.
 *
 * Sem colunas de links e sem redes sociais: o mapa do site e os perfis oficiais
 * ainda não existem, e um ícone apontando para endereço adivinhado é pior do que
 * a ausência dele.
 */
export function AppFooter() {
  return (
    <footer className="border-t border-divider bg-background">
      <div className="flex flex-col items-start gap-4 px-4 py-8 min-[992px]:flex-row min-[992px]:items-center min-[992px]:gap-8 min-[992px]:px-10">
        <img
          src="/marca-gef-horizontal.svg"
          alt="GEF Áreas Privadas"
          className="h-(--gef-rodape-marca-altura) w-auto"
        />
        <p className="m-0 text-xs font-medium text-primary">{RESPONSAVEIS}</p>
      </div>
    </footer>
  )
}
